const INIT_STATE = {
    snoList: [],
    snoTotal: 0,
    snoUnfilteredTotal: 0,
    snoOffset: 0,
    snoNextOffset: 0,
    snoLimit: 100,
    snoSearch: {
        searchField: null,
        searchQuery: '',
        rawSearchQuery: '',
        searchPrefix: '',
    },
    snoListRevision: 0,
    isSnoListLoading: false,
    active: '',
    activeStation: null,
    slotsList: {},
    logsList: [],
    datetime: '',
    socket: null,
    isLoading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'LOADING_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'LOADING_END':
            return {
                ...state,
                isLoading: false,
            };
        case 'SNO_LIST_LOADING_START':
            return {
                ...state,
                isSnoListLoading: true,
            };
        case 'SNO_LIST_LOADING_END':
            return {
                ...state,
                isSnoListLoading: false,
            };
        case 'SNO_LIST_LOAD': {
            const nextSnoList = action.payload.append
                ? [...state.snoList, ...action.payload.rows]
                : action.payload.rows;
            const nextActiveStation =
                nextSnoList.find(station => station.sno === state.active) || state.activeStation;

            return {
                ...state,
                snoList: nextSnoList,
                snoTotal: action.payload.count,
                snoUnfilteredTotal: action.payload.search.searchField
                    ? state.snoUnfilteredTotal
                    : action.payload.count,
                snoOffset: action.payload.offset,
                snoNextOffset: action.payload.offset + action.payload.rows.length,
                snoLimit: action.payload.limit,
                snoSearch: action.payload.search,
                snoListRevision: state.snoListRevision + 1,
                isSnoListLoading: false,
                activeStation: nextActiveStation,
            };
        }
        case 'FIRMWARE_VERSION_UPDATED':
            return {
                ...state,
                snoList: state.snoList.map(station =>
                    station.sno === action.payload.sno
                        ? {
                              ...station,
                              firmware_version: action.payload.firmware_version,
                              firmware_version_updated:
                                  action.payload.firmware_version_updated,
                          }
                        : station,
                ),
                activeStation:
                    state.activeStation && state.activeStation.sno === action.payload.sno
                        ? {
                              ...state.activeStation,
                              firmware_version: action.payload.firmware_version,
                              firmware_version_updated:
                                  action.payload.firmware_version_updated,
                          }
                        : state.activeStation,
            };
        case 'APK_VERSION_UPDATED':
            return {
                ...state,
                snoList: state.snoList.map(station =>
                    station.sno === action.payload.sno
                        ? {
                              ...station,
                              apk_version: action.payload.apk_version,
                              apk_version_updated: action.payload.apk_version_updated,
                          }
                        : station,
                ),
                activeStation:
                    state.activeStation && state.activeStation.sno === action.payload.sno
                        ? {
                              ...state.activeStation,
                              apk_version: action.payload.apk_version,
                              apk_version_updated: action.payload.apk_version_updated,
                          }
                        : state.activeStation,
            };
        case 'SLOTS_LIST_LOAD':
            return {
                ...state,
                slotsList: action.payload,
                isLoading: false,
            };
        case 'SLOTS_LIST_ERROR':
            return {
                ...state,
                active: null,
                activeStation: null,
                isLoading: false,
            };
        case 'LOGS_LIST_LOAD':
            return {
                ...state,
                logsList: action.payload,
                isLoading: false,
            };
        case 'EXTRACT':
            return {
                ...state,
                extract: action.payload,
                isLoading: false,
            };
        case 'CHOICE':
            return {
                ...state,
                active: action.payload.sno,
                activeStation:
                    state.snoList.find(station => station.sno === action.payload.sno) || null,
                datetime: action.payload.datetime,
                logsList: [],
                isLoading: false,
            };
        case 'ADMIN_STATUS_UPDATED': {
            return {
                ...state,
                isLoading: false,
                slotsList: {
                    ...state.slotsList,
                    [[parseInt(action.payload.pksnopos.split(':')[1])].admin_status]:
                        action.payload.admin_status,
                },
            };
        }
        case 'CONFLICT_STATUS_UPDATED': {
            return {
                ...state,
                slotsList: {
                    ...state.slotsList,
                    [[parseInt(action.payload.pksnopos.split(':')[1])].conflict_status]:
                        action.payload.conflict_status,
                },
            };
        }
        case 'WS_CONNECTED':
            state.socket && state.socket.disconnect();
            return {
                ...state,
                socket: action.payload,
            };
        case 'WS_MESSAGE':
            return {
                ...state,
                logsList: [action.payload, ...state.logsList],
            };
        case 'WS_CLOSED':
            return {
                ...state,
                socket: null,
            };
        case 'WS_CLOSE':
            return {
                ...state,
                socket: null,
            };
        default:
            return state;
    }
};
